import React from 'react'
import {
  Card,
  CardHeader,
  Table
} from 'reactstrap'
import PriceUtil from 'utils/price-util'
import PropTypes from 'prop-types'

const propTypes = {
  revenue: PropTypes.shape({
    total_fee_payment_amount : PropTypes.number,
    inbounds                 : PropTypes.arrayOf(
      PropTypes.shape({
        code               : PropTypes.string,
        fee_payment_amount : PropTypes.number
      })
    )
  })
}

const defaultProps = {
  revenue: {
    total_fee_payment_amount : 0,
    inbounds                 : [ {
      code               : '',
      fee_payment_amount : 0
    } ]
  }
}

const RevenueProcessingFeeDetailCard = ({ revenue }) => (
  <Card>
    <CardHeader className='font-weight-bold'>
      { 'Processing Fee Details' }
    </CardHeader>
    <div style={{ overflowX: 'auto' }}>
      <Table className="mb-0">
        <thead
          className='font-weight-bold text-center w-100'
          style={{ background: '#5e72e4', color: 'white' }}
        >
          <tr>
            <th>INBOUND CODE</th>
            <th>PROCESSING FEE</th>
          </tr>
        </thead>
        <tbody>

          {
            revenue.inbounds.map((inbound) => (
              <tr key={ inbound.code }>
                <td>
                  { inbound.code }
                </td>
                <td>
                  { inbound.fee_payment_amount }
                </td>
              </tr>
            ))
          }

          <tr className='font-weight-bold border'>
            <td>
                Total
            </td>
            <td>
              { PriceUtil.format(revenue.total_fee_payment_amount) }
            </td>
          </tr>

        </tbody>
      </Table>
    </div>
  </Card>
)

RevenueProcessingFeeDetailCard.propTypes    = propTypes
RevenueProcessingFeeDetailCard.defaultProps = defaultProps

export default RevenueProcessingFeeDetailCard
